module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_4-b042135d28dc10b54074c834dea661ad.jpg";